export const PLAY_PACKAGE = "com.dhrudhew.daywia";
// Canonical host is www; the apex 301-redirects to www at the CDN (_redirects).
export const INVITE_HOST = "www.daywia.com";

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isInviteUserId(value: string | undefined): value is string {
  return Boolean(value && UUID_RE.test(value.trim()));
}

export function buildInviteWebUrl(inviterId: string): string {
  return `https://${INVITE_HOST}/invite/${inviterId.trim()}`;
}

export function buildPlayStoreInviteUrl(inviterId: string): string {
  const referrer = encodeURIComponent(`invite=${inviterId.trim()}`);
  return `https://play.google.com/store/apps/details?id=${PLAY_PACKAGE}&referrer=${referrer}`;
}

export function buildAppDeepLink(inviterId: string): string {
  return `daywia://invite/${inviterId.trim()}`;
}

export function buildAndroidIntentInviteUrl(inviterId: string): string {
  const id = inviterId.trim();
  const fallback = encodeURIComponent(buildPlayStoreInviteUrl(id));
  return `intent://invite/${id}#Intent;scheme=daywia;package=${PLAY_PACKAGE};S.browser_fallback_url=${fallback};end`;
}

export function isAndroidDevice(): boolean {
  return typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent);
}
